var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "home-things-to-do" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "things-to-do-items" }, [
      _c(
        "div",
        { staticClass: "things-to-do-left" },
        _vm._l(_vm.thingsToDoActive, function(item, idx) {
          return _c(
            "div",
            {
              key: "tdi-" + idx,
              staticClass: "things-to-do-item",
              class: { active: item == _vm.activeSection },
              on: {
                mouseenter: function($event) {
                  return _vm.setActive(item)
                },
                mouseleave: function($event) {
                  _vm.hovering = false
                }
              }
            },
            [
              _c(
                "a",
                {
                  staticClass: "things-to-do-thumb",
                  attrs: { href: item.link.url, target: item.link.target }
                },
                [
                  _c("img", {
                    attrs: {
                      src: item.image.sizes.medium_large,
                      title: item.title
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "things-to-do-content",
                  attrs: { href: item.link.url, target: item.link.target }
                },
                [
                  _c("h5", { domProps: { innerHTML: _vm._s(item.headline) } }),
                  _vm._v(" "),
                  _c("h4", { domProps: { innerHTML: _vm._s(item.title) } }),
                  _vm._v(" "),
                  _c("p", { domProps: { innerHTML: _vm._s(item.body) } })
                ]
              )
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "things-to-do-right" },
        _vm._l(_vm.thingsToDoRight, function(item, idx) {
          return _c(
            "div",
            {
              key: "tdi-" + idx,
              staticClass: "things-to-do-item",
              class: { active: item == _vm.activeSection },
              on: {
                mouseenter: function($event) {
                  return _vm.setActive(item)
                },
                mouseleave: function($event) {
                  _vm.hovering = false
                }
              }
            },
            [
              _c(
                "a",
                {
                  staticClass: "things-to-do-thumb",
                  attrs: { href: item.link.url, target: item.link.target }
                },
                [
                  _c("img", {
                    attrs: {
                      src: item.image.sizes.medium_large,
                      title: item.title
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "things-to-do-content" }, [
                _c("h4", { domProps: { innerHTML: _vm._s(item.title) } })
              ])
            ]
          )
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "home-section-header" }, [
      _c("h3", [_vm._v("THINGS TO DO")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /Users/nick/Desktop/Projects/kinston/wp-content/themes/kinston/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/Users/nick/Desktop/Projects/kinston/wp-content/themes/kinston/node_modules/vue-loader/lib?{}!/Users/nick/Desktop/Projects/kinston/wp-content/themes/kinston/node_modules/vue-svg-inline-loader/dist/index.min.js?{}!./scripts/components/HomeThingsToDo.vue?vue&type=template&id=729311a8&
// module id = 389
// module chunks = 0